import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { License } from 'src/app/models/activity_license_search_response';
import { ApiService } from 'src/services/apiService';
import { SweetAlertService } from 'src/services/sweetAlertService';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-activity-license-manage',
  templateUrl: './activity-license-manage.component.html',
  styleUrls: ['./activity-license-manage.component.css']
})
export class ActivityLicenseManageComponent {
  edit: boolean = false;
  licenses: License[] = [];
  enterpriseNationalNumber: string = '';
  licenseNumber: string = '';
  activityForm: FormGroup;

  fields = [
    { label: 'رقم المستثمر', control: 'investorId' },

    { label: 'رقم الرخصة', control: 'licenseId' },

    { label: 'فئة الرخصة', control: 'classNameAr' , controlType:'Select',
      options:[
        "أولى",
        "ثانية",
        "ثالثة",
      ]
     },

    { label: 'فئة الرخصة بالانجليزية ', control: 'classNameEn' , controlType:'Select',
      options:[
        "First",
        "Second",
        "Third",
      ]
     },

    { label: 'رخصة لعام', control: 'licenseYear' },

    { label: 'الرقم الوطني', control: 'nationalId' },

    { label: 'اسم المؤسسة', control: 'companyName' },
    { label: 'اسم المؤسسة بالانجليزية', control: 'companyName_en' },

    { label: 'الاسم التجاري', control: 'tradeName' },
    { label: 'الاسم التجاري بالانجليزية', control: 'tradeName_en' },

    { label: 'وصف النشاط', control: 'activityDescription' },
    { label: 'وصف النشاط بالانجليزية' , control: 'activityDescription_en' },

    { label: 'مرافق النشاط', control: 'activityFacilities' },
    { label: ' مرافق النشاط بالانجليزية', control: 'activityFacilities_en' },

    { label: 'اسم المنطقة', control: 'regionName' },
    { label: 'اسم المنطقة بالانجليزية', control: 'regionName_en' },

    { label: 'مالك العقار', control: 'propertyOwner' },
    { label: 'مالك العقار بالانجليزية', control: 'propertyOwner_en' },

    { label: 'قطعة رقم', control: 'landNumber' },

    { label: 'اسم الحوض', control: 'basinName' },
    { label: ' اسم الحوض بالانجليزية ' , control: 'basinName_en' },

    { label: 'بناية رقم', control: 'buildingNumber' },

    { label: 'طابق رقم', control: 'floorNumber' },
    { label: 'Floor Number', control: 'floorNumber_en' },

    { label: 'تاريخ الاصدار', control: 'issueDate' , controlType:'Date' },

    { label: 'تاريخ الانتهاء', control: 'expiryDate' , controlType:'Date' },
  ];

  constructor(private apiService: ApiService, private fb: FormBuilder, private sweetAlertService: SweetAlertService) {
    const group: any = {};
    this.fields.forEach(field => {
      group[field.control] = ['', Validators.required];
    });

    this.activityForm = this.fb.group(group);

    // 👇 Subscribe to form changes
    this.activityForm.valueChanges.subscribe((formValues) => {
      if (this.licenses.length > 0) {
        const license = this.licenses[0];

        // Update only mapped fields
        license.investorNumber = formValues.investorId;
        license.licenseNumber = formValues.licenseId;
        license.licenseClassAr = formValues.licenseCategory;
        license.licenseClassEn = formValues.licenseCategory_en;
        license.licenseYear = formValues.licenseYear;
        license.enterpriseNationalNumber = formValues.nationalId;
        license.enterpriseNameAr = formValues.companyName;
        license.enterpriseNameEn = formValues.companyName_en;
        license.tradeNameAr = formValues.tradeName;
        license.tradeNameEn = formValues.tradeName_en;
        license.activityDescriptionAr = formValues.activityDescription;
        license.activityDescriptionEn = formValues.activityDescription_en;
        license.activityFacilitiesAr = formValues.activityFacilities;
        license.activityFacilitiesEn = formValues.activityFacilities_en;
        license.zoneNameAr = formValues.regionName;
        license.zoneNameEn = formValues.regionName_en;
        license.propertyOwnerAr = formValues.propertyOwner;
        license.propertyOwnerEn = formValues.propertyOwner_en;
        license.landNumber = formValues.landNumber;
        license.basinNameAr = formValues.basinName;
        license.basinNameEn = formValues.basinName_en;
        license.buildingNumber = formValues.buildingNumber;
        license.floorNumberAr = formValues.floorNumber;
        license.floorNumberEn = formValues.floorNumber_en;

        // Parse dates if needed
        license.issueDate = formValues.issueDate;
        license.expiryDate = formValues.expiryDate;
      }
    });
  }

  clearForm(): void {
    this.activityForm.reset();
    this.enterpriseNationalNumber = "";
    this.licenseNumber = "";
    this.licenses = [];
    this.edit = false// Clears all fields to initial state (empty)
  }



  onSearch() {

    const queryParams = `enterpriseNationalNumber=${encodeURIComponent(this.enterpriseNationalNumber)}&licenseNumber=${encodeURIComponent(this.licenseNumber)}`;

    var link = "ActivtyLicense/SearchActivityLicense?" + queryParams;

    this.apiService.get(link, environment.getterLink).subscribe(({
      next: (response) => {
        try {
          this.licenses = response.licenses;

          if (this.licenses && this.licenses.length > 0) {
            this.edit = true;
            const license = this.licenses[0];

            if(license.licenseClassAr=="اولى"){
              license.licenseClassAr="أولى";
            }

            if(license.licenseClassEn=="أولى" || license.licenseClassEn=="اولى"){
              license.licenseClassEn="First";
            }else if(license.licenseClassEn=="ثانية"){
              license.licenseClassEn="Second";
            }else if(license.licenseClassEn=="ثالثة"){
              license.licenseClassEn="Third";
            }

            // Patch the form with values
            this.activityForm.patchValue({
              investorId: license.investorNumber,

              licenseId: license.licenseNumber,

              classNameAr: license.licenseClassAr,
              classNameEn: license.licenseClassEn,

              licenseYear: license.licenseYear,
              licenseYear_en: license.licenseYear,

              nationalId: license.enterpriseNationalNumber,

              companyName: license.enterpriseNameAr,
              companyName_en: license.enterpriseNameEn,

              tradeName: license.tradeNameAr,
              tradeName_en: license.tradeNameEn,

              activityDescription: license.activityDescriptionAr,
              activityDescription_en: license.activityDescriptionEn,

              activityFacilities: license.activityFacilitiesAr,
              activityFacilities_en: license.activityFacilitiesEn,

              regionName: license.zoneNameAr,
              regionName_en: license.zoneNameEn,

              propertyOwner: license.propertyOwnerAr,
              propertyOwner_en: license.propertyOwnerEn,

              landNumber: license.landNumber,
              landNumber_en: license.landNumber,

              basinName: license.basinNameAr,
              basinName_en: license.basinNameEn,

              buildingNumber: license.buildingNumber,
              buildingNumber_en: license.buildingNumber,

              floorNumber: license.floorNumberAr,
              floorNumber_en: license.floorNumberEn,

              issueDate: license.issueDate ? this.formatDate(license.issueDate) : '',

              expiryDate: license.expiryDate ? this.formatDate(license.expiryDate) : '',
            });
          }


        } catch (error) {
          this.edit = false;
          this.clearForm()
          this.sweetAlertService.ShowAlert("info", "")

        }
      },
      error: (error) => {
        this.edit = false;
        this.clearForm()
        this.sweetAlertService.ShowAlert("info", "no data found")

      }
    }));
  }

  save() {

    if (this.activityForm.valid) {
      const value = this.licenses[0];


      var investorId = this.activityForm.get('investorId');
      var licenseId = this.activityForm.get('licenseId');
      var classNameAr = this.activityForm.get('classNameAr');
      var classNameEn = this.activityForm.get('classNameEn');
      var licenseYear = this.activityForm.get('licenseYear');
      var nationalId = this.activityForm.get('nationalId');
      var companyName = this.activityForm.get('companyName');
      var companyName_en = this.activityForm.get('companyName_en');
      var tradeName = this.activityForm.get('tradeName');
      var tradeName_en = this.activityForm.get('tradeName_en');
      var activityDescription = this.activityForm.get('activityDescription');
      var activityDescription_en = this.activityForm.get('activityDescription_en');
      var activityFacilities = this.activityForm.get('activityFacilities');
      var activityFacilities_en = this.activityForm.get('activityFacilities_en');
      var regionName = this.activityForm.get('regionName');
      var regionName_en = this.activityForm.get('regionName_en');
      var propertyOwner = this.activityForm.get('propertyOwner');
      var propertyOwner_en = this.activityForm.get('propertyOwner_en');
      var landNumber = this.activityForm.get('landNumber');
      var basinName = this.activityForm.get('basinName');
      var basinName_en = this.activityForm.get('basinName_en');
      var buildingNumber = this.activityForm.get('buildingNumber');
      var floorNumber = this.activityForm.get('floorNumber');
      var floorNumber_en = this.activityForm.get('floorNumber_en');
      var issueDate = this.activityForm.get('issueDate');
      var expiryDate = this.activityForm.get('expiryDate');

      const payload = {
        licenseNumber: value?.licenseNumber ?? licenseId?.value,
        investorNumber: value?.investorNumber ?? investorId?.value,
        licenseClassAr: value?.licenseClassAr ?? classNameAr?.value,
        licenseClassEn: value?.licenseClassEn ?? classNameEn?.value,
        licenseYear: value?.licenseYear ?? licenseYear?.value,
        enterpriseNationalNumber: value?.enterpriseNationalNumber ?? nationalId?.value,
        enterpriseNameAr: value?.enterpriseNameAr ?? companyName?.value,
        enterpriseNameEn: value?.enterpriseNameEn ?? companyName_en?.value,
        tradeNameAr: value?.tradeNameAr ?? tradeName?.value,
        tradeNameEn: value?.tradeNameEn ?? tradeName_en?.value,
        activityDescriptionAr: value?.activityDescriptionAr ?? activityDescription?.value,
        activityDescriptionEn: value?.activityDescriptionEn ?? activityDescription_en?.value,
        activityFacilitiesAr: value?.activityFacilitiesAr ?? activityFacilities?.value,
        activityFacilitiesEn: value?.activityFacilitiesEn ?? activityFacilities_en?.value,
        zoneNameAr: value?.zoneNameAr ?? regionName?.value,
        zoneNameEn: value?.zoneNameEn ?? regionName_en?.value,
        propertyOwnerAr: value?.propertyOwnerAr ?? propertyOwner?.value,
        propertyOwnerEn: value?.propertyOwnerEn ?? propertyOwner_en?.value,
        landNumber: value?.landNumber ?? landNumber?.value,
        basinNameAr: value?.basinNameAr ?? basinName?.value,
        basinNameEn: value?.basinNameEn ?? basinName_en?.value,
        buildingNumber: value?.buildingNumber ?? buildingNumber?.value,
        floorNumberAr:value?.floorNumberAr ?? floorNumber?.value,
        floorNumberEn:value?.floorNumberEn ?? floorNumber_en?.value,
        issueDate: value?.issueDate ?? issueDate?.value,
        expiryDate: value?.expiryDate ?? expiryDate?.value,
      };

      this.apiService.post("ActivtyLicense/AddEditActivityLicenseForWeb", payload, environment.getterLink).subscribe(({
        next: (response) => {
          this.sweetAlertService.ShowAlertThenRedirect("success", "edit successfully",'Investment/ControlPanel/manage-activity-license')
        },
        error: (error) => {

          this.sweetAlertService.ShowAlert("error", error)
          // Handle error: show user-friendly error message
        }
      }));

    } else {
      this.activityForm.markAllAsTouched(); // Show validation errors
    }

  }


  private formatDate(date: Date): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

}
